module.exports = __webpack_public_path__ + "static/media/phone.e908706c.svg";